import { districtSummary, REGION_LABELS } from './districtSummary';
import { EVENT_TYPE_LABELS, DAY_LABELS, TIME_RANGE_LABELS, TECH_LABELS, BUDGET_MODEL_LABELS } from '../constants/canonicalEnums';
export { REGION_LABELS } from './districtSummary';

// A7: bölge belirteçleri ("İstanbul geneli"/yakalar) ilçe listesine açılmadan okunur adla gösterilir.
// Kullanıcının "kesin / olmazsa olmaz" işaretleyebildiği koşul grupları (backend matchmaking.HARD_GROUPS).
export const HARD_GROUP_LABELS = { days: 'Gün', time_ranges: 'Saat', budget: 'Bütçe', technical: 'Teknik ihtiyaç', features: 'Mekân imkânları' };
export const FILTER_LABELS = {
  venue_concept: 'Mekân türü', music_needed: 'Müzik', alcohol_free: 'Alkolsüz mekân gerekli',
  event_type: 'Etkinlik', event_types: 'Etkinlik türleri', expected_attendees: 'Kişi sayısı', preferred_districts: 'İlçe',
  preferred_neighborhoods: 'Mahalle / semt', excluded_neighborhoods: 'İstenmeyen mahalle / semt',
  excluded_districts: 'İstenmeyen ilçe', preferred_days: 'Gün', excluded_days: 'İstenmeyen gün',
  preferred_time_ranges: 'Saat', venue_budget_model: 'Ödeme koşulu', venue_budget_max_try: 'Bütçe üst sınırı',
  technical_needs: 'Gerekli ekipman', alcohol_needed: 'Alkol servisi gerekli', outside_materials_needed: 'Dışarıdan malzeme gerekli',
  table_setup_needed: 'Masa düzeni gerekli', needs_two_person_table_setup: '2 kişilik masa gerekli',
  min_table_size_expectation: 'Minimum masa ölçüsü', needs_personal_workspace: 'Kişi başı çalışma alanı gerekli',
  hard: 'Kesin koşullar',
};
export const filterValue = (field, value) => {
  const tables = { event_type: EVENT_TYPE_LABELS, event_types: EVENT_TYPE_LABELS, preferred_days: DAY_LABELS, excluded_days: DAY_LABELS,
    preferred_time_ranges: TIME_RANGE_LABELS, technical_needs: TECH_LABELS, venue_budget_model: BUDGET_MODEL_LABELS,
    preferred_districts: REGION_LABELS, excluded_districts: REGION_LABELS,
    venue_concept: { meyhane: 'Meyhane', yeni_nesil_meyhane: 'Yeni nesil meyhane' } };
  if (['preferred_districts', 'excluded_districts'].includes(field)) return districtSummary(value);
  if (field === 'hard') {
    const names = Array.isArray(value) ? value : Object.keys(value || {}).filter(k => value[k] === true);
    return [...new Set(names.map(n => HARD_GROUP_LABELS[n] || FILTER_LABELS[n] || n))].join(', ');
  }
  if (field === 'music_needed' && typeof value === 'boolean') return value ? 'Müzikli mekân' : 'Müziksiz mekân';
  if (typeof value === 'boolean') return value ? 'Evet' : 'Gerekli değil';
  if (field === 'venue_budget_max_try') return `${Number(value).toLocaleString('tr-TR')} TL`;
  const label = v => tables[field]?.[v] || String(v);
  return Array.isArray(value) ? value.map(label).join(', ') : label(value);
};
const present = (key, value) => value != null && value !== '' && (!Array.isArray(value) || value.length > 0)
  && (key !== 'hard' || (Array.isArray(value) ? value.length > 0 : Object.values(value).some(v => v === true)));
export const appliedFilterLabels = filters => Object.entries(FILTER_LABELS)
  .filter(([key]) => present(key, filters?.[key]))
  .map(([key, label]) => `${label}: ${filterValue(key, filters[key])}`);
